module.exports = __webpack_public_path__ + "img/action-8.c8eb180a.svg";